<template>
    <div class="change-password-view">
        <section class="l-stack l-gap-2">
            <h2>{{ $t('title') }}</h2>

            <BaseCard padded class="l-stack l-gap-3">
                <ChangePasswordForm
                    ref="form"
                    @disabled="isDisabled = $event"
                    @loading="isLoading = $event"
                />

                <div class="l-inline l-justify-end">
                    <BaseButton
                        size="small"
                        :disabled="isDisabled"
                        :is-loading="isLoading"
                        @click="handleSubmit"
                    >
                        {{ $t('shared.save') }}
                    </BaseButton>
                </div>
            </BaseCard>
        </section>
    </div>
</template>

<script>
import BaseButton from '../redesigned/BaseButton'
import BaseCard from '../redesigned/BaseCard'
import ChangePasswordForm from '../ChangePasswordForm'

export default {
    name: 'ChangePasswordView',
    components: {
        BaseButton,
        BaseCard,
        ChangePasswordForm,
    },
    data() {
        return {
            isDisabled: false,
            isLoading: false,
        }
    },
    methods: {
        handleSubmit() {
            this.$refs.form?.handleSubmit()
        },
    },
}
</script>

<i18n>
{
    "en": {
        "title": "Change password"
    },
    "de": {
        "title": "Passwort ändern"
    },
    "fr": {
        "title": "Modifier le mot de passe"
    },
    "it": {
        "title": "Modificare Password"
    }
}
</i18n>

<style lang="scss" scoped>
.change-password-view {
    padding: 3rem 1rem;
    width: 100%;
    height: 100%;
    background-color: $color-bg-new;

    section {
        margin-right: auto;
        margin-left: auto;
        width: 100%;
        max-width: 400px;

        & > h2 {
            font-size: 20px;
            color: #000;
        }
    }
}
</style>
